module.exports = __webpack_public_path__ + "static/media/gallery-1.5d9827fd.png";